<script lang="ts" setup>
import { useUserStore } from '@/store/user/user'

const { isAuthenticated } = storeToRefs(useUserStore())

const isLoading = ref(true)

const title = computed(() => {
  return isAuthenticated.value ? 'Профиль' : 'Вход'
})

const showLoadingState = computed(() => {
  return isLoading.value && !isAuthenticated.value
})

const onProfileClick = () => {
  isAuthenticated.value ? navigateTo('/profile/orders/') : navigateTo('/login/')
}

onMounted(() => (isLoading.value = false))
</script>

<template>
  <the-button
    v-if="showLoadingState"
    variant="tertiary"
    size="sm"
    radius="lg"
    width="140"
    :loading="true"
  />

  <the-button
    v-if="!showLoadingState"
    data-test-id="headerAuthButton"
    variant="tertiary"
    size="sm"
    radius="lg"
    width="140"
    @click="onProfileClick"
  >
    <the-icon name="user--filled" size="24" />
    {{ title }}
  </the-button>
</template>
